import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';
import { ReactComponent as CloseIco } from '../../assets/svg/utils/close.svg';
import { TDefaultDrawerProps, TDrawerSide } from '../../types/components';
import Button from '../Button';

const contentAnimations = {
  bottom: {
    initial: { y: '100%' },
    animate: { y: '0%', transition: { duration: 0.4, ease: 'easeOut' } },
    exit: { y: '100%', transition: { duration: 0.3, ease: 'easeIn' } },
  },
  left: {},
  right: {},
  top: {},
};

const classNames = {
  right: 'inset-y-0 right-0',
  left: 'inset-y-0 left-0',
  top: 'inset-x-0 top-0',
  bottom: 'inset-x-0 bottom-0',
};

export type DrawerProps = TDefaultDrawerProps & {
  side: TDrawerSide;
  children?: ReactNode;
  wrapperClassName?: string;
  closeStroke?: string;
  hideClose?: boolean;
};

function Drawer({
  open, onClose, side = 'bottom', children, wrapperClassName, closeStroke, hideClose,
}: DrawerProps) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[1600] bg-black bg-opacity-80 flex justify-center items-end"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
        >
          <motion.div
            className={`pointer-events-auto fixed max-w-full ${classNames[side]}`}
            variants={contentAnimations[side]}
            initial="initial"
            animate="animate"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`relative flex flex-col overflow-y-auto shadow-xl rounded-t-[20px] bg-black-modal-bg z-10 ${wrapperClassName || 'h-60'}`}>
              {!hideClose && (
              <Button pureClass className="absolute right-4 top-3 cursor-pointer z-[1000]" onClick={onClose}>
                <CloseIco className={`stroke-${closeStroke || '[#5F6168]'}`} />
              </Button>
              )}
              {children}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Drawer;
